/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  DeleteInvoiceCompaniesId200,
  FinancialDetailedSummary,
  FinancialInvoices,
  FinancialSummary,
  FinancialYearlySummary,
  GetFinancialSummaryDetailedParams,
  GetFinancialSummaryYearlyParams,
  GetInvoiceCompanies200Item,
  GetInvoiceCompaniesId200,
  GetInvoiceCompaniesIdInvoiceFields200,
  GetInvoiceCompaniesParams,
  GetInvoicesParams,
  GetOutgoingInvoicesParams,
  InvoiceApprovalStatus,
  InvoiceAttachmentStored,
  InvoiceConfirmed,
  InvoicePdfStored,
  InvoiceRequest,
  InvoiceTestDataSeeded,
  Listing,
  NextInvoiceNumber,
  OutgoingInvoice,
  OutgoingInvoiceCreated,
  OutgoingInvoiceRequest,
  OutgoingInvoiceSummary,
  ParsedInvoicePdf,
  PatchInvoiceCompaniesId200,
  PatchInvoiceCompaniesIdBody,
  PatchRecurringInvoicesTemplateIdBody,
  PostInvoiceCompanies201,
  PostInvoiceCompaniesBody,
  PostInvoicesInvoiceIdUploadAttachmentBody,
  PostInvoicesInvoiceIdUploadPdfBody,
  PostInvoicesParsePdfBody,
  RecurringInvoiceCreated,
  RecurringInvoiceTemplate,
  RecurringInvoiceTemplateRequest,
  ReplaceInvoiceLinesRequest,
  Run,
  SupplierInvoice,
  SupplierInvoiceHeader,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getPutInvoicesInvoiceIdLinesUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}/lines`
}

/**
 * @summary Replace every line on an invoice, in one exchange
 */
export const putInvoicesInvoiceIdLines = async (
  invoiceId: number,
  replaceInvoiceLinesRequest: ReplaceInvoiceLinesRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPutInvoicesInvoiceIdLinesUrl(invoiceId), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(replaceInvoiceLinesRequest),
  })
}

export const getPutInvoicesInvoiceIdLinesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putInvoicesInvoiceIdLines>>,
    TError,
    { invoiceId: number; data: ReplaceInvoiceLinesRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putInvoicesInvoiceIdLines>>,
  TError,
  { invoiceId: number; data: ReplaceInvoiceLinesRequest },
  TContext
> => {
  const mutationKey = ['putInvoicesInvoiceIdLines']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putInvoicesInvoiceIdLines>>,
    { invoiceId: number; data: ReplaceInvoiceLinesRequest }
  > = (props) => {
    const { invoiceId, data } = props ?? {}

    return putInvoicesInvoiceIdLines(invoiceId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutInvoicesInvoiceIdLinesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putInvoicesInvoiceIdLines>>
>
export type PutInvoicesInvoiceIdLinesMutationBody = ReplaceInvoiceLinesRequest
export type PutInvoicesInvoiceIdLinesMutationError = unknown

/**
 * @summary Replace every line on an invoice, in one exchange
 */
export const usePutInvoicesInvoiceIdLines = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putInvoicesInvoiceIdLines>>,
      TError,
      { invoiceId: number; data: ReplaceInvoiceLinesRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putInvoicesInvoiceIdLines>>,
  TError,
  { invoiceId: number; data: ReplaceInvoiceLinesRequest },
  TContext
> => {
  return useMutation(getPutInvoicesInvoiceIdLinesMutationOptions(options), queryClient)
}
export const getPostSeedInvoiceTestDataUrl = () => {
  return `/api/v1/seed-invoice-test-data`
}

/**
 * @summary Insert sample invoicing data (non-production environments only)
 */
export const postSeedInvoiceTestData = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<InvoiceTestDataSeeded> => {
  return customFetch<InvoiceTestDataSeeded>(getPostSeedInvoiceTestDataUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostSeedInvoiceTestDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postSeedInvoiceTestData>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postSeedInvoiceTestData>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postSeedInvoiceTestData']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postSeedInvoiceTestData>>,
    void
  > = () => {
    return postSeedInvoiceTestData(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostSeedInvoiceTestDataMutationResult = NonNullable<
  Awaited<ReturnType<typeof postSeedInvoiceTestData>>
>

export type PostSeedInvoiceTestDataMutationError = unknown

/**
 * @summary Insert sample invoicing data (non-production environments only)
 */
export const usePostSeedInvoiceTestData = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postSeedInvoiceTestData>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postSeedInvoiceTestData>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostSeedInvoiceTestDataMutationOptions(options), queryClient)
}
export const getGetRecurringInvoicesUrl = () => {
  return `/api/v1/recurring-invoices`
}

/**
 * @summary The standing charges, active ones first
 */
export const getRecurringInvoices = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<RecurringInvoiceTemplate[]> => {
  return customFetch<RecurringInvoiceTemplate[]>(getGetRecurringInvoicesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetRecurringInvoicesQueryKey = () => {
  return [`/api/v1/recurring-invoices`] as const
}

export const getGetRecurringInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecurringInvoices>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRecurringInvoices>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetRecurringInvoicesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecurringInvoices>>> = ({ signal }) =>
    getRecurringInvoices({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecurringInvoices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRecurringInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecurringInvoices>>
>
export type GetRecurringInvoicesQueryError = unknown

export function useGetRecurringInvoices<
  TData = Awaited<ReturnType<typeof getRecurringInvoices>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecurringInvoices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecurringInvoices>>,
          TError,
          Awaited<ReturnType<typeof getRecurringInvoices>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecurringInvoices<
  TData = Awaited<ReturnType<typeof getRecurringInvoices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecurringInvoices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRecurringInvoices>>,
          TError,
          Awaited<ReturnType<typeof getRecurringInvoices>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRecurringInvoices<
  TData = Awaited<ReturnType<typeof getRecurringInvoices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecurringInvoices>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The standing charges, active ones first
 */

export function useGetRecurringInvoices<
  TData = Awaited<ReturnType<typeof getRecurringInvoices>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRecurringInvoices>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetRecurringInvoicesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostRecurringInvoicesUrl = () => {
  return `/api/v1/recurring-invoices`
}

/**
 * @summary Add a standing charge
 */
export const postRecurringInvoices = async (
  recurringInvoiceTemplateRequest: RecurringInvoiceTemplateRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<RecurringInvoiceCreated> => {
  return customFetch<RecurringInvoiceCreated>(getPostRecurringInvoicesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(recurringInvoiceTemplateRequest),
  })
}

export const getPostRecurringInvoicesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRecurringInvoices>>,
    TError,
    { data: RecurringInvoiceTemplateRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRecurringInvoices>>,
  TError,
  { data: RecurringInvoiceTemplateRequest },
  TContext
> => {
  const mutationKey = ['postRecurringInvoices']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRecurringInvoices>>,
    { data: RecurringInvoiceTemplateRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postRecurringInvoices(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostRecurringInvoicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRecurringInvoices>>
>
export type PostRecurringInvoicesMutationBody = RecurringInvoiceTemplateRequest
export type PostRecurringInvoicesMutationError = unknown

/**
 * @summary Add a standing charge
 */
export const usePostRecurringInvoices = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRecurringInvoices>>,
      TError,
      { data: RecurringInvoiceTemplateRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRecurringInvoices>>,
  TError,
  { data: RecurringInvoiceTemplateRequest },
  TContext
> => {
  return useMutation(getPostRecurringInvoicesMutationOptions(options), queryClient)
}
export const getPostRecurringInvoicesRunUrl = () => {
  return `/api/v1/recurring-invoices/run`
}

/**
 * @summary Generate this month's invoices for every charge that is due
 */
export const postRecurringInvoicesRun = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<Run> => {
  return customFetch<Run>(getPostRecurringInvoicesRunUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostRecurringInvoicesRunMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postRecurringInvoicesRun>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postRecurringInvoicesRun>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postRecurringInvoicesRun']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postRecurringInvoicesRun>>,
    void
  > = () => {
    return postRecurringInvoicesRun(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostRecurringInvoicesRunMutationResult = NonNullable<
  Awaited<ReturnType<typeof postRecurringInvoicesRun>>
>

export type PostRecurringInvoicesRunMutationError = unknown

/**
 * @summary Generate this month's invoices for every charge that is due
 */
export const usePostRecurringInvoicesRun = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postRecurringInvoicesRun>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postRecurringInvoicesRun>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostRecurringInvoicesRunMutationOptions(options), queryClient)
}
export const getGetOutgoingInvoicesUrl = (params?: GetOutgoingInvoicesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/outgoing-invoices?${stringifiedParams}`
    : `/api/v1/outgoing-invoices`
}

/**
 * @summary Issued invoices, newest first
 */
export const getOutgoingInvoices = async (
  params?: GetOutgoingInvoicesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<OutgoingInvoiceSummary[]> => {
  return customFetch<OutgoingInvoiceSummary[]>(getGetOutgoingInvoicesUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetOutgoingInvoicesQueryKey = (params?: GetOutgoingInvoicesParams) => {
  return [`/api/v1/outgoing-invoices`, ...(params ? [params] : [])] as const
}

export const getGetOutgoingInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutgoingInvoices>>,
  TError = unknown,
>(
  params?: GetOutgoingInvoicesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoices>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOutgoingInvoicesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOutgoingInvoices>>> = ({ signal }) =>
    getOutgoingInvoices(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOutgoingInvoices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOutgoingInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOutgoingInvoices>>
>
export type GetOutgoingInvoicesQueryError = unknown

export function useGetOutgoingInvoices<
  TData = Awaited<ReturnType<typeof getOutgoingInvoices>>,
  TError = unknown,
>(
  params: undefined | GetOutgoingInvoicesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoices>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutgoingInvoices>>,
          TError,
          Awaited<ReturnType<typeof getOutgoingInvoices>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutgoingInvoices<
  TData = Awaited<ReturnType<typeof getOutgoingInvoices>>,
  TError = unknown,
>(
  params?: GetOutgoingInvoicesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoices>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutgoingInvoices>>,
          TError,
          Awaited<ReturnType<typeof getOutgoingInvoices>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutgoingInvoices<
  TData = Awaited<ReturnType<typeof getOutgoingInvoices>>,
  TError = unknown,
>(
  params?: GetOutgoingInvoicesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoices>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Issued invoices, newest first
 */

export function useGetOutgoingInvoices<
  TData = Awaited<ReturnType<typeof getOutgoingInvoices>>,
  TError = unknown,
>(
  params?: GetOutgoingInvoicesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoices>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOutgoingInvoicesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostOutgoingInvoicesUrl = () => {
  return `/api/v1/outgoing-invoices`
}

/**
 * @summary Issue an invoice
 */
export const postOutgoingInvoices = async (
  outgoingInvoiceRequest: OutgoingInvoiceRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<OutgoingInvoiceCreated> => {
  return customFetch<OutgoingInvoiceCreated>(getPostOutgoingInvoicesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(outgoingInvoiceRequest),
  })
}

export const getPostOutgoingInvoicesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOutgoingInvoices>>,
    TError,
    { data: OutgoingInvoiceRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOutgoingInvoices>>,
  TError,
  { data: OutgoingInvoiceRequest },
  TContext
> => {
  const mutationKey = ['postOutgoingInvoices']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOutgoingInvoices>>,
    { data: OutgoingInvoiceRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postOutgoingInvoices(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOutgoingInvoicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOutgoingInvoices>>
>
export type PostOutgoingInvoicesMutationBody = OutgoingInvoiceRequest
export type PostOutgoingInvoicesMutationError = unknown

/**
 * @summary Issue an invoice
 */
export const usePostOutgoingInvoices = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOutgoingInvoices>>,
      TError,
      { data: OutgoingInvoiceRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOutgoingInvoices>>,
  TError,
  { data: OutgoingInvoiceRequest },
  TContext
> => {
  return useMutation(getPostOutgoingInvoicesMutationOptions(options), queryClient)
}
export const getPostOutgoingInvoicesInvoiceIdMarkPaidUrl = (invoiceId: number) => {
  return `/api/v1/outgoing-invoices/${invoiceId}/mark-paid`
}

/**
 * @summary Record that an issued invoice was paid
 */
export const postOutgoingInvoicesInvoiceIdMarkPaid = async (
  invoiceId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPostOutgoingInvoicesInvoiceIdMarkPaidUrl(invoiceId), {
    ...options,
    method: 'POST',
  })
}

export const getPostOutgoingInvoicesInvoiceIdMarkPaidMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOutgoingInvoicesInvoiceIdMarkPaid>>,
    TError,
    { invoiceId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOutgoingInvoicesInvoiceIdMarkPaid>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  const mutationKey = ['postOutgoingInvoicesInvoiceIdMarkPaid']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOutgoingInvoicesInvoiceIdMarkPaid>>,
    { invoiceId: number }
  > = (props) => {
    const { invoiceId } = props ?? {}

    return postOutgoingInvoicesInvoiceIdMarkPaid(invoiceId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOutgoingInvoicesInvoiceIdMarkPaidMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOutgoingInvoicesInvoiceIdMarkPaid>>
>

export type PostOutgoingInvoicesInvoiceIdMarkPaidMutationError = unknown

/**
 * @summary Record that an issued invoice was paid
 */
export const usePostOutgoingInvoicesInvoiceIdMarkPaid = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOutgoingInvoicesInvoiceIdMarkPaid>>,
      TError,
      { invoiceId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOutgoingInvoicesInvoiceIdMarkPaid>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  return useMutation(getPostOutgoingInvoicesInvoiceIdMarkPaidMutationOptions(options), queryClient)
}
export const getPostOutgoingInvoicesInvoiceIdCancelUrl = (invoiceId: number) => {
  return `/api/v1/outgoing-invoices/${invoiceId}/cancel`
}

/**
 * @summary Cancel an issued invoice
 */
export const postOutgoingInvoicesInvoiceIdCancel = async (
  invoiceId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPostOutgoingInvoicesInvoiceIdCancelUrl(invoiceId), {
    ...options,
    method: 'POST',
  })
}

export const getPostOutgoingInvoicesInvoiceIdCancelMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOutgoingInvoicesInvoiceIdCancel>>,
    TError,
    { invoiceId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOutgoingInvoicesInvoiceIdCancel>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  const mutationKey = ['postOutgoingInvoicesInvoiceIdCancel']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOutgoingInvoicesInvoiceIdCancel>>,
    { invoiceId: number }
  > = (props) => {
    const { invoiceId } = props ?? {}

    return postOutgoingInvoicesInvoiceIdCancel(invoiceId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostOutgoingInvoicesInvoiceIdCancelMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOutgoingInvoicesInvoiceIdCancel>>
>

export type PostOutgoingInvoicesInvoiceIdCancelMutationError = unknown

/**
 * @summary Cancel an issued invoice
 */
export const usePostOutgoingInvoicesInvoiceIdCancel = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOutgoingInvoicesInvoiceIdCancel>>,
      TError,
      { invoiceId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOutgoingInvoicesInvoiceIdCancel>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  return useMutation(getPostOutgoingInvoicesInvoiceIdCancelMutationOptions(options), queryClient)
}
export const getGetInvoicesUrl = (params?: GetInvoicesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/api/v1/invoices?${stringifiedParams}` : `/api/v1/invoices`
}

/**
 * @summary The invoices, newest first
 */
export const getInvoices = async (
  params?: GetInvoicesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<Listing> => {
  return customFetch<Listing>(getGetInvoicesUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetInvoicesQueryKey = (params?: GetInvoicesParams) => {
  return [`/api/v1/invoices`, ...(params ? [params] : [])] as const
}

export const getGetInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoices>>,
  TError = unknown,
>(
  params?: GetInvoicesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetInvoicesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoices>>> = ({ signal }) =>
    getInvoices(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvoices>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoices>>>
export type GetInvoicesQueryError = unknown

export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>(
  params: undefined | GetInvoicesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>(
  params?: GetInvoicesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>(
  params?: GetInvoicesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The invoices, newest first
 */

export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = unknown>(
  params?: GetInvoicesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetInvoicesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostInvoicesUrl = () => {
  return `/api/v1/invoices`
}

/**
 * @summary Record an invoice and its lines
 */
export const postInvoices = async (
  invoiceRequest: InvoiceRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierInvoice> => {
  return customFetch<SupplierInvoice>(getPostInvoicesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(invoiceRequest),
  })
}

export const getPostInvoicesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postInvoices>>,
    TError,
    { data: InvoiceRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postInvoices>>,
  TError,
  { data: InvoiceRequest },
  TContext
> => {
  const mutationKey = ['postInvoices']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postInvoices>>,
    { data: InvoiceRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postInvoices(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostInvoicesMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoices>>>
export type PostInvoicesMutationBody = InvoiceRequest
export type PostInvoicesMutationError = unknown

/**
 * @summary Record an invoice and its lines
 */
export const usePostInvoices = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postInvoices>>,
      TError,
      { data: InvoiceRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postInvoices>>,
  TError,
  { data: InvoiceRequest },
  TContext
> => {
  return useMutation(getPostInvoicesMutationOptions(options), queryClient)
}
export const getPostInvoicesInvoiceIdUploadPdfUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}/upload-pdf`
}

/**
 * @summary Attach the supplier's PDF to an invoice
 */
export const postInvoicesInvoiceIdUploadPdf = async (
  invoiceId: number,
  postInvoicesInvoiceIdUploadPdfBody?: PostInvoicesInvoiceIdUploadPdfBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<InvoicePdfStored> => {
  const formData = new FormData()
  if (postInvoicesInvoiceIdUploadPdfBody?.pdf !== undefined) {
    formData.append(`pdf`, postInvoicesInvoiceIdUploadPdfBody.pdf)
  }

  return customFetch<InvoicePdfStored>(getPostInvoicesInvoiceIdUploadPdfUrl(invoiceId), {
    ...options,
    method: 'POST',
    body: formData,
  })
}

export const getPostInvoicesInvoiceIdUploadPdfMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdUploadPdf>>,
    TError,
    { invoiceId: number; data?: PostInvoicesInvoiceIdUploadPdfBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdUploadPdf>>,
  TError,
  { invoiceId: number; data?: PostInvoicesInvoiceIdUploadPdfBody },
  TContext
> => {
  const mutationKey = ['postInvoicesInvoiceIdUploadPdf']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdUploadPdf>>,
    { invoiceId: number; data?: PostInvoicesInvoiceIdUploadPdfBody }
  > = (props) => {
    const { invoiceId, data } = props ?? {}

    return postInvoicesInvoiceIdUploadPdf(invoiceId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostInvoicesInvoiceIdUploadPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdUploadPdf>>
>
export type PostInvoicesInvoiceIdUploadPdfMutationBody =
  PostInvoicesInvoiceIdUploadPdfBody | undefined
export type PostInvoicesInvoiceIdUploadPdfMutationError = unknown

/**
 * @summary Attach the supplier's PDF to an invoice
 */
export const usePostInvoicesInvoiceIdUploadPdf = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postInvoicesInvoiceIdUploadPdf>>,
      TError,
      { invoiceId: number; data?: PostInvoicesInvoiceIdUploadPdfBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdUploadPdf>>,
  TError,
  { invoiceId: number; data?: PostInvoicesInvoiceIdUploadPdfBody },
  TContext
> => {
  return useMutation(getPostInvoicesInvoiceIdUploadPdfMutationOptions(options), queryClient)
}
export const getPostInvoicesInvoiceIdUploadAttachmentUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}/upload-attachment`
}

/**
 * @summary Attach a photograph of the paper document to an invoice
 */
export const postInvoicesInvoiceIdUploadAttachment = async (
  invoiceId: number,
  postInvoicesInvoiceIdUploadAttachmentBody?: PostInvoicesInvoiceIdUploadAttachmentBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<InvoiceAttachmentStored> => {
  const formData = new FormData()
  if (postInvoicesInvoiceIdUploadAttachmentBody?.photo !== undefined) {
    formData.append(`photo`, postInvoicesInvoiceIdUploadAttachmentBody.photo)
  }

  return customFetch<InvoiceAttachmentStored>(
    getPostInvoicesInvoiceIdUploadAttachmentUrl(invoiceId),
    {
      ...options,
      method: 'POST',
      body: formData,
    },
  )
}

export const getPostInvoicesInvoiceIdUploadAttachmentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdUploadAttachment>>,
    TError,
    { invoiceId: number; data?: PostInvoicesInvoiceIdUploadAttachmentBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdUploadAttachment>>,
  TError,
  { invoiceId: number; data?: PostInvoicesInvoiceIdUploadAttachmentBody },
  TContext
> => {
  const mutationKey = ['postInvoicesInvoiceIdUploadAttachment']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdUploadAttachment>>,
    { invoiceId: number; data?: PostInvoicesInvoiceIdUploadAttachmentBody }
  > = (props) => {
    const { invoiceId, data } = props ?? {}

    return postInvoicesInvoiceIdUploadAttachment(invoiceId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostInvoicesInvoiceIdUploadAttachmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdUploadAttachment>>
>
export type PostInvoicesInvoiceIdUploadAttachmentMutationBody =
  PostInvoicesInvoiceIdUploadAttachmentBody | undefined
export type PostInvoicesInvoiceIdUploadAttachmentMutationError = unknown

/**
 * @summary Attach a photograph of the paper document to an invoice
 */
export const usePostInvoicesInvoiceIdUploadAttachment = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postInvoicesInvoiceIdUploadAttachment>>,
      TError,
      { invoiceId: number; data?: PostInvoicesInvoiceIdUploadAttachmentBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdUploadAttachment>>,
  TError,
  { invoiceId: number; data?: PostInvoicesInvoiceIdUploadAttachmentBody },
  TContext
> => {
  return useMutation(getPostInvoicesInvoiceIdUploadAttachmentMutationOptions(options), queryClient)
}
export const getPostInvoicesInvoiceIdMarkUnpaidUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}/mark-unpaid`
}

/**
 * @summary Undo a payment mark
 */
export const postInvoicesInvoiceIdMarkUnpaid = async (
  invoiceId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierInvoiceHeader> => {
  return customFetch<SupplierInvoiceHeader>(getPostInvoicesInvoiceIdMarkUnpaidUrl(invoiceId), {
    ...options,
    method: 'POST',
  })
}

export const getPostInvoicesInvoiceIdMarkUnpaidMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdMarkUnpaid>>,
    TError,
    { invoiceId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdMarkUnpaid>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  const mutationKey = ['postInvoicesInvoiceIdMarkUnpaid']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdMarkUnpaid>>,
    { invoiceId: number }
  > = (props) => {
    const { invoiceId } = props ?? {}

    return postInvoicesInvoiceIdMarkUnpaid(invoiceId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostInvoicesInvoiceIdMarkUnpaidMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdMarkUnpaid>>
>

export type PostInvoicesInvoiceIdMarkUnpaidMutationError = unknown

/**
 * @summary Undo a payment mark
 */
export const usePostInvoicesInvoiceIdMarkUnpaid = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postInvoicesInvoiceIdMarkUnpaid>>,
      TError,
      { invoiceId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdMarkUnpaid>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  return useMutation(getPostInvoicesInvoiceIdMarkUnpaidMutationOptions(options), queryClient)
}
export const getPostInvoicesInvoiceIdMarkPaidUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}/mark-paid`
}

/**
 * @summary Mark an invoice paid
 */
export const postInvoicesInvoiceIdMarkPaid = async (
  invoiceId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierInvoiceHeader> => {
  return customFetch<SupplierInvoiceHeader>(getPostInvoicesInvoiceIdMarkPaidUrl(invoiceId), {
    ...options,
    method: 'POST',
  })
}

export const getPostInvoicesInvoiceIdMarkPaidMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdMarkPaid>>,
    TError,
    { invoiceId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdMarkPaid>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  const mutationKey = ['postInvoicesInvoiceIdMarkPaid']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdMarkPaid>>,
    { invoiceId: number }
  > = (props) => {
    const { invoiceId } = props ?? {}

    return postInvoicesInvoiceIdMarkPaid(invoiceId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostInvoicesInvoiceIdMarkPaidMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdMarkPaid>>
>

export type PostInvoicesInvoiceIdMarkPaidMutationError = unknown

/**
 * @summary Mark an invoice paid
 */
export const usePostInvoicesInvoiceIdMarkPaid = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postInvoicesInvoiceIdMarkPaid>>,
      TError,
      { invoiceId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdMarkPaid>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  return useMutation(getPostInvoicesInvoiceIdMarkPaidMutationOptions(options), queryClient)
}
export const getPostInvoicesInvoiceIdConfirmUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}/confirm`
}

/**
 * Resolves each line's stock item from the supplier's own codes, learns a mapping the operator picked by hand, appends the price history, and creates the stock receipt and movements.
 *
 * Idempotent: the receipt is tagged `invoice:<id>` and a second confirm finds it and stocks nothing, so a double-click cannot receive a delivery twice.
 *
 * Answers **403** with `requiresApproval` and `threshold` when the invoice is over the configured gate and nobody has approved it.
 * @summary Confirm an invoice, and receive the goods onto the shelf
 */
export const postInvoicesInvoiceIdConfirm = async (
  invoiceId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<InvoiceConfirmed> => {
  return customFetch<InvoiceConfirmed>(getPostInvoicesInvoiceIdConfirmUrl(invoiceId), {
    ...options,
    method: 'POST',
  })
}

export const getPostInvoicesInvoiceIdConfirmMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdConfirm>>,
    TError,
    { invoiceId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdConfirm>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  const mutationKey = ['postInvoicesInvoiceIdConfirm']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdConfirm>>,
    { invoiceId: number }
  > = (props) => {
    const { invoiceId } = props ?? {}

    return postInvoicesInvoiceIdConfirm(invoiceId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostInvoicesInvoiceIdConfirmMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdConfirm>>
>

export type PostInvoicesInvoiceIdConfirmMutationError = unknown

/**
 * @summary Confirm an invoice, and receive the goods onto the shelf
 */
export const usePostInvoicesInvoiceIdConfirm = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postInvoicesInvoiceIdConfirm>>,
      TError,
      { invoiceId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdConfirm>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  return useMutation(getPostInvoicesInvoiceIdConfirmMutationOptions(options), queryClient)
}
export const getPostInvoicesInvoiceIdApproveUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}/approve`
}

/**
 * @summary Approve an invoice for payment
 */
export const postInvoicesInvoiceIdApprove = async (
  invoiceId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierInvoiceHeader> => {
  return customFetch<SupplierInvoiceHeader>(getPostInvoicesInvoiceIdApproveUrl(invoiceId), {
    ...options,
    method: 'POST',
  })
}

export const getPostInvoicesInvoiceIdApproveMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdApprove>>,
    TError,
    { invoiceId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdApprove>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  const mutationKey = ['postInvoicesInvoiceIdApprove']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postInvoicesInvoiceIdApprove>>,
    { invoiceId: number }
  > = (props) => {
    const { invoiceId } = props ?? {}

    return postInvoicesInvoiceIdApprove(invoiceId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostInvoicesInvoiceIdApproveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdApprove>>
>

export type PostInvoicesInvoiceIdApproveMutationError = unknown

/**
 * @summary Approve an invoice for payment
 */
export const usePostInvoicesInvoiceIdApprove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postInvoicesInvoiceIdApprove>>,
      TError,
      { invoiceId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postInvoicesInvoiceIdApprove>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  return useMutation(getPostInvoicesInvoiceIdApproveMutationOptions(options), queryClient)
}
export const getPostInvoicesParsePdfUrl = () => {
  return `/api/v1/invoices/parse-pdf`
}

/**
 * @summary Read a supplier PDF into a draft invoice
 */
export const postInvoicesParsePdf = async (
  postInvoicesParsePdfBody?: PostInvoicesParsePdfBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<ParsedInvoicePdf> => {
  const formData = new FormData()
  if (postInvoicesParsePdfBody?.pdf !== undefined) {
    formData.append(`pdf`, postInvoicesParsePdfBody.pdf)
  }

  return customFetch<ParsedInvoicePdf>(getPostInvoicesParsePdfUrl(), {
    ...options,
    method: 'POST',
    body: formData,
  })
}

export const getPostInvoicesParsePdfMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postInvoicesParsePdf>>,
    TError,
    { data?: PostInvoicesParsePdfBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postInvoicesParsePdf>>,
  TError,
  { data?: PostInvoicesParsePdfBody },
  TContext
> => {
  const mutationKey = ['postInvoicesParsePdf']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postInvoicesParsePdf>>,
    { data?: PostInvoicesParsePdfBody }
  > = (props) => {
    const { data } = props ?? {}

    return postInvoicesParsePdf(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostInvoicesParsePdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInvoicesParsePdf>>
>
export type PostInvoicesParsePdfMutationBody = PostInvoicesParsePdfBody | undefined
export type PostInvoicesParsePdfMutationError = unknown

/**
 * @summary Read a supplier PDF into a draft invoice
 */
export const usePostInvoicesParsePdf = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postInvoicesParsePdf>>,
      TError,
      { data?: PostInvoicesParsePdfBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postInvoicesParsePdf>>,
  TError,
  { data?: PostInvoicesParsePdfBody },
  TContext
> => {
  return useMutation(getPostInvoicesParsePdfMutationOptions(options), queryClient)
}
export const getGetInvoiceCompaniesUrl = (params?: GetInvoiceCompaniesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/invoice-companies?${stringifiedParams}`
    : `/api/v1/invoice-companies`
}

/**
 * @summary Companies this restaurant issues invoices to
 */
export const getInvoiceCompanies = async (
  params?: GetInvoiceCompaniesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetInvoiceCompanies200Item[]> => {
  return customFetch<GetInvoiceCompanies200Item[]>(getGetInvoiceCompaniesUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetInvoiceCompaniesQueryKey = (params?: GetInvoiceCompaniesParams) => {
  return [`/api/v1/invoice-companies`, ...(params ? [params] : [])] as const
}

export const getGetInvoiceCompaniesQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoiceCompanies>>,
  TError = unknown,
>(
  params?: GetInvoiceCompaniesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompanies>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetInvoiceCompaniesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceCompanies>>> = ({ signal }) =>
    getInvoiceCompanies(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvoiceCompanies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoiceCompaniesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvoiceCompanies>>
>
export type GetInvoiceCompaniesQueryError = unknown

export function useGetInvoiceCompanies<
  TData = Awaited<ReturnType<typeof getInvoiceCompanies>>,
  TError = unknown,
>(
  params: undefined | GetInvoiceCompaniesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompanies>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoiceCompanies>>,
          TError,
          Awaited<ReturnType<typeof getInvoiceCompanies>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoiceCompanies<
  TData = Awaited<ReturnType<typeof getInvoiceCompanies>>,
  TError = unknown,
>(
  params?: GetInvoiceCompaniesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompanies>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoiceCompanies>>,
          TError,
          Awaited<ReturnType<typeof getInvoiceCompanies>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoiceCompanies<
  TData = Awaited<ReturnType<typeof getInvoiceCompanies>>,
  TError = unknown,
>(
  params?: GetInvoiceCompaniesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompanies>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Companies this restaurant issues invoices to
 */

export function useGetInvoiceCompanies<
  TData = Awaited<ReturnType<typeof getInvoiceCompanies>>,
  TError = unknown,
>(
  params?: GetInvoiceCompaniesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompanies>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetInvoiceCompaniesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostInvoiceCompaniesUrl = () => {
  return `/api/v1/invoice-companies`
}

/**
 * @summary Add a company
 */
export const postInvoiceCompanies = async (
  postInvoiceCompaniesBody?: PostInvoiceCompaniesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PostInvoiceCompanies201> => {
  return customFetch<PostInvoiceCompanies201>(getPostInvoiceCompaniesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postInvoiceCompaniesBody),
  })
}

export const getPostInvoiceCompaniesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postInvoiceCompanies>>,
    TError,
    { data?: PostInvoiceCompaniesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postInvoiceCompanies>>,
  TError,
  { data?: PostInvoiceCompaniesBody },
  TContext
> => {
  const mutationKey = ['postInvoiceCompanies']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postInvoiceCompanies>>,
    { data?: PostInvoiceCompaniesBody }
  > = (props) => {
    const { data } = props ?? {}

    return postInvoiceCompanies(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostInvoiceCompaniesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postInvoiceCompanies>>
>
export type PostInvoiceCompaniesMutationBody = PostInvoiceCompaniesBody | undefined
export type PostInvoiceCompaniesMutationError = unknown

/**
 * @summary Add a company
 */
export const usePostInvoiceCompanies = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postInvoiceCompanies>>,
      TError,
      { data?: PostInvoiceCompaniesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postInvoiceCompanies>>,
  TError,
  { data?: PostInvoiceCompaniesBody },
  TContext
> => {
  return useMutation(getPostInvoiceCompaniesMutationOptions(options), queryClient)
}
export const getDeleteRecurringInvoicesTemplateIdUrl = (templateId: number) => {
  return `/api/v1/recurring-invoices/${templateId}`
}

/**
 * @summary Remove a standing charge
 */
export const deleteRecurringInvoicesTemplateId = async (
  templateId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteRecurringInvoicesTemplateIdUrl(templateId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteRecurringInvoicesTemplateIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRecurringInvoicesTemplateId>>,
    TError,
    { templateId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRecurringInvoicesTemplateId>>,
  TError,
  { templateId: number },
  TContext
> => {
  const mutationKey = ['deleteRecurringInvoicesTemplateId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRecurringInvoicesTemplateId>>,
    { templateId: number }
  > = (props) => {
    const { templateId } = props ?? {}

    return deleteRecurringInvoicesTemplateId(templateId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteRecurringInvoicesTemplateIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRecurringInvoicesTemplateId>>
>

export type DeleteRecurringInvoicesTemplateIdMutationError = unknown

/**
 * @summary Remove a standing charge
 */
export const useDeleteRecurringInvoicesTemplateId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRecurringInvoicesTemplateId>>,
      TError,
      { templateId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRecurringInvoicesTemplateId>>,
  TError,
  { templateId: number },
  TContext
> => {
  return useMutation(getDeleteRecurringInvoicesTemplateIdMutationOptions(options), queryClient)
}
export const getPatchRecurringInvoicesTemplateIdUrl = (templateId: number) => {
  return `/api/v1/recurring-invoices/${templateId}`
}

/**
 * @summary Change a standing charge
 */
export const patchRecurringInvoicesTemplateId = async (
  templateId: number,
  patchRecurringInvoicesTemplateIdBody: PatchRecurringInvoicesTemplateIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPatchRecurringInvoicesTemplateIdUrl(templateId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchRecurringInvoicesTemplateIdBody),
  })
}

export const getPatchRecurringInvoicesTemplateIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchRecurringInvoicesTemplateId>>,
    TError,
    { templateId: number; data: PatchRecurringInvoicesTemplateIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchRecurringInvoicesTemplateId>>,
  TError,
  { templateId: number; data: PatchRecurringInvoicesTemplateIdBody },
  TContext
> => {
  const mutationKey = ['patchRecurringInvoicesTemplateId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchRecurringInvoicesTemplateId>>,
    { templateId: number; data: PatchRecurringInvoicesTemplateIdBody }
  > = (props) => {
    const { templateId, data } = props ?? {}

    return patchRecurringInvoicesTemplateId(templateId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchRecurringInvoicesTemplateIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchRecurringInvoicesTemplateId>>
>
export type PatchRecurringInvoicesTemplateIdMutationBody = PatchRecurringInvoicesTemplateIdBody
export type PatchRecurringInvoicesTemplateIdMutationError = unknown

/**
 * @summary Change a standing charge
 */
export const usePatchRecurringInvoicesTemplateId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchRecurringInvoicesTemplateId>>,
      TError,
      { templateId: number; data: PatchRecurringInvoicesTemplateIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchRecurringInvoicesTemplateId>>,
  TError,
  { templateId: number; data: PatchRecurringInvoicesTemplateIdBody },
  TContext
> => {
  return useMutation(getPatchRecurringInvoicesTemplateIdMutationOptions(options), queryClient)
}
export const getGetInvoicesInvoiceIdUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}`
}

/**
 * @summary One invoice, with its lines
 */
export const getInvoicesInvoiceId = async (
  invoiceId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierInvoice> => {
  return customFetch<SupplierInvoice>(getGetInvoicesInvoiceIdUrl(invoiceId), {
    ...options,
    method: 'GET',
  })
}

export const getGetInvoicesInvoiceIdQueryKey = (invoiceId: number) => {
  return [`/api/v1/invoices/${invoiceId}`] as const
}

export const getGetInvoicesInvoiceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceId>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetInvoicesInvoiceIdQueryKey(invoiceId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicesInvoiceId>>> = ({ signal }) =>
    getInvoicesInvoiceId(invoiceId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: invoiceId !== null && invoiceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetInvoicesInvoiceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvoicesInvoiceId>>
>
export type GetInvoicesInvoiceIdQueryError = unknown

export function useGetInvoicesInvoiceId<
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceId>>,
  TError = unknown,
>(
  invoiceId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesInvoiceId>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesInvoiceId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesInvoiceId<
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceId>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesInvoiceId>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesInvoiceId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesInvoiceId<
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceId>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One invoice, with its lines
 */

export function useGetInvoicesInvoiceId<
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceId>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetInvoicesInvoiceIdQueryOptions(invoiceId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteInvoicesInvoiceIdUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}`
}

/**
 * @summary Delete an invoice and its lines
 */
export const deleteInvoicesInvoiceId = async (
  invoiceId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteInvoicesInvoiceIdUrl(invoiceId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteInvoicesInvoiceIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInvoicesInvoiceId>>,
    TError,
    { invoiceId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInvoicesInvoiceId>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  const mutationKey = ['deleteInvoicesInvoiceId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInvoicesInvoiceId>>,
    { invoiceId: number }
  > = (props) => {
    const { invoiceId } = props ?? {}

    return deleteInvoicesInvoiceId(invoiceId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteInvoicesInvoiceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInvoicesInvoiceId>>
>

export type DeleteInvoicesInvoiceIdMutationError = unknown

/**
 * @summary Delete an invoice and its lines
 */
export const useDeleteInvoicesInvoiceId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteInvoicesInvoiceId>>,
      TError,
      { invoiceId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteInvoicesInvoiceId>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  return useMutation(getDeleteInvoicesInvoiceIdMutationOptions(options), queryClient)
}
export const getPatchInvoicesInvoiceIdUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}`
}

/**
 * @summary Change an invoice's header
 */
export const patchInvoicesInvoiceId = async (
  invoiceId: number,
  invoiceRequest: InvoiceRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierInvoiceHeader> => {
  return customFetch<SupplierInvoiceHeader>(getPatchInvoicesInvoiceIdUrl(invoiceId), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(invoiceRequest),
  })
}

export const getPatchInvoicesInvoiceIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchInvoicesInvoiceId>>,
    TError,
    { invoiceId: number; data: InvoiceRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchInvoicesInvoiceId>>,
  TError,
  { invoiceId: number; data: InvoiceRequest },
  TContext
> => {
  const mutationKey = ['patchInvoicesInvoiceId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchInvoicesInvoiceId>>,
    { invoiceId: number; data: InvoiceRequest }
  > = (props) => {
    const { invoiceId, data } = props ?? {}

    return patchInvoicesInvoiceId(invoiceId, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchInvoicesInvoiceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchInvoicesInvoiceId>>
>
export type PatchInvoicesInvoiceIdMutationBody = InvoiceRequest
export type PatchInvoicesInvoiceIdMutationError = unknown

/**
 * @summary Change an invoice's header
 */
export const usePatchInvoicesInvoiceId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchInvoicesInvoiceId>>,
      TError,
      { invoiceId: number; data: InvoiceRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchInvoicesInvoiceId>>,
  TError,
  { invoiceId: number; data: InvoiceRequest },
  TContext
> => {
  return useMutation(getPatchInvoicesInvoiceIdMutationOptions(options), queryClient)
}
export const getGetInvoiceCompaniesIdUrl = (id: number) => {
  return `/api/v1/invoice-companies/${id}`
}

/**
 * @summary One company
 */
export const getInvoiceCompaniesId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetInvoiceCompaniesId200> => {
  return customFetch<GetInvoiceCompaniesId200>(getGetInvoiceCompaniesIdUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetInvoiceCompaniesIdQueryKey = (id: number) => {
  return [`/api/v1/invoice-companies/${id}`] as const
}

export const getGetInvoiceCompaniesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoiceCompaniesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompaniesId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetInvoiceCompaniesIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceCompaniesId>>> = ({ signal }) =>
    getInvoiceCompaniesId(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompaniesId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetInvoiceCompaniesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvoiceCompaniesId>>
>
export type GetInvoiceCompaniesIdQueryError = unknown

export function useGetInvoiceCompaniesId<
  TData = Awaited<ReturnType<typeof getInvoiceCompaniesId>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompaniesId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoiceCompaniesId>>,
          TError,
          Awaited<ReturnType<typeof getInvoiceCompaniesId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoiceCompaniesId<
  TData = Awaited<ReturnType<typeof getInvoiceCompaniesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompaniesId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoiceCompaniesId>>,
          TError,
          Awaited<ReturnType<typeof getInvoiceCompaniesId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoiceCompaniesId<
  TData = Awaited<ReturnType<typeof getInvoiceCompaniesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompaniesId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One company
 */

export function useGetInvoiceCompaniesId<
  TData = Awaited<ReturnType<typeof getInvoiceCompaniesId>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompaniesId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetInvoiceCompaniesIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteInvoiceCompaniesIdUrl = (id: number) => {
  return `/api/v1/invoice-companies/${id}`
}

/**
 * @summary Remove a company from the list
 */
export const deleteInvoiceCompaniesId = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<DeleteInvoiceCompaniesId200> => {
  return customFetch<DeleteInvoiceCompaniesId200>(getDeleteInvoiceCompaniesIdUrl(id), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteInvoiceCompaniesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteInvoiceCompaniesId>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteInvoiceCompaniesId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteInvoiceCompaniesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteInvoiceCompaniesId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return deleteInvoiceCompaniesId(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteInvoiceCompaniesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteInvoiceCompaniesId>>
>

export type DeleteInvoiceCompaniesIdMutationError = unknown

/**
 * @summary Remove a company from the list
 */
export const useDeleteInvoiceCompaniesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteInvoiceCompaniesId>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteInvoiceCompaniesId>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getDeleteInvoiceCompaniesIdMutationOptions(options), queryClient)
}
export const getPatchInvoiceCompaniesIdUrl = (id: number) => {
  return `/api/v1/invoice-companies/${id}`
}

/**
 * @summary Change a company
 */
export const patchInvoiceCompaniesId = async (
  id: number,
  patchInvoiceCompaniesIdBody?: PatchInvoiceCompaniesIdBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PatchInvoiceCompaniesId200> => {
  return customFetch<PatchInvoiceCompaniesId200>(getPatchInvoiceCompaniesIdUrl(id), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchInvoiceCompaniesIdBody),
  })
}

export const getPatchInvoiceCompaniesIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchInvoiceCompaniesId>>,
    TError,
    { id: number; data?: PatchInvoiceCompaniesIdBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchInvoiceCompaniesId>>,
  TError,
  { id: number; data?: PatchInvoiceCompaniesIdBody },
  TContext
> => {
  const mutationKey = ['patchInvoiceCompaniesId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchInvoiceCompaniesId>>,
    { id: number; data?: PatchInvoiceCompaniesIdBody }
  > = (props) => {
    const { id, data } = props ?? {}

    return patchInvoiceCompaniesId(id, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PatchInvoiceCompaniesIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchInvoiceCompaniesId>>
>
export type PatchInvoiceCompaniesIdMutationBody = PatchInvoiceCompaniesIdBody | undefined
export type PatchInvoiceCompaniesIdMutationError = unknown

/**
 * @summary Change a company
 */
export const usePatchInvoiceCompaniesId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchInvoiceCompaniesId>>,
      TError,
      { id: number; data?: PatchInvoiceCompaniesIdBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchInvoiceCompaniesId>>,
  TError,
  { id: number; data?: PatchInvoiceCompaniesIdBody },
  TContext
> => {
  return useMutation(getPatchInvoiceCompaniesIdMutationOptions(options), queryClient)
}
export const getGetOutgoingInvoicesInvoiceIdUrl = (invoiceId: number) => {
  return `/api/v1/outgoing-invoices/${invoiceId}`
}

/**
 * @summary One issued invoice, with its lines
 */
export const getOutgoingInvoicesInvoiceId = async (
  invoiceId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<OutgoingInvoice> => {
  return customFetch<OutgoingInvoice>(getGetOutgoingInvoicesInvoiceIdUrl(invoiceId), {
    ...options,
    method: 'GET',
  })
}

export const getGetOutgoingInvoicesInvoiceIdQueryKey = (invoiceId: number) => {
  return [`/api/v1/outgoing-invoices/${invoiceId}`] as const
}

export const getGetOutgoingInvoicesInvoiceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOutgoingInvoicesInvoiceIdQueryKey(invoiceId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>> = ({
    signal,
  }) => getOutgoingInvoicesInvoiceId(invoiceId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: invoiceId !== null && invoiceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetOutgoingInvoicesInvoiceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>
>
export type GetOutgoingInvoicesInvoiceIdQueryError = unknown

export function useGetOutgoingInvoicesInvoiceId<
  TData = Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>,
  TError = unknown,
>(
  invoiceId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>,
          TError,
          Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutgoingInvoicesInvoiceId<
  TData = Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>,
          TError,
          Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutgoingInvoicesInvoiceId<
  TData = Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One issued invoice, with its lines
 */

export function useGetOutgoingInvoicesInvoiceId<
  TData = Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoicesInvoiceId>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOutgoingInvoicesInvoiceIdQueryOptions(invoiceId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getDeleteOutgoingInvoicesInvoiceIdUrl = (invoiceId: number) => {
  return `/api/v1/outgoing-invoices/${invoiceId}`
}

/**
 * @summary Delete an issued invoice that was never paid
 */
export const deleteOutgoingInvoicesInvoiceId = async (
  invoiceId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteOutgoingInvoicesInvoiceIdUrl(invoiceId), {
    ...options,
    method: 'DELETE',
  })
}

export const getDeleteOutgoingInvoicesInvoiceIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOutgoingInvoicesInvoiceId>>,
    TError,
    { invoiceId: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOutgoingInvoicesInvoiceId>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  const mutationKey = ['deleteOutgoingInvoicesInvoiceId']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOutgoingInvoicesInvoiceId>>,
    { invoiceId: number }
  > = (props) => {
    const { invoiceId } = props ?? {}

    return deleteOutgoingInvoicesInvoiceId(invoiceId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteOutgoingInvoicesInvoiceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOutgoingInvoicesInvoiceId>>
>

export type DeleteOutgoingInvoicesInvoiceIdMutationError = unknown

/**
 * @summary Delete an issued invoice that was never paid
 */
export const useDeleteOutgoingInvoicesInvoiceId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOutgoingInvoicesInvoiceId>>,
      TError,
      { invoiceId: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOutgoingInvoicesInvoiceId>>,
  TError,
  { invoiceId: number },
  TContext
> => {
  return useMutation(getDeleteOutgoingInvoicesInvoiceIdMutationOptions(options), queryClient)
}
export const getGetOutgoingInvoicesNextNumberUrl = () => {
  return `/api/v1/outgoing-invoices/next-number`
}

/**
 * @summary The number the next issued invoice will get
 */
export const getOutgoingInvoicesNextNumber = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<NextInvoiceNumber> => {
  return customFetch<NextInvoiceNumber>(getGetOutgoingInvoicesNextNumberUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetOutgoingInvoicesNextNumberQueryKey = () => {
  return [`/api/v1/outgoing-invoices/next-number`] as const
}

export const getGetOutgoingInvoicesNextNumberQueryOptions = <
  TData = Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetOutgoingInvoicesNextNumberQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>> = ({
    signal,
  }) => getOutgoingInvoicesNextNumber({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOutgoingInvoicesNextNumberQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>
>
export type GetOutgoingInvoicesNextNumberQueryError = unknown

export function useGetOutgoingInvoicesNextNumber<
  TData = Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>,
          TError,
          Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutgoingInvoicesNextNumber<
  TData = Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>,
          TError,
          Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutgoingInvoicesNextNumber<
  TData = Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The number the next issued invoice will get
 */

export function useGetOutgoingInvoicesNextNumber<
  TData = Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOutgoingInvoicesNextNumber>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOutgoingInvoicesNextNumberQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetInvoicesInvoiceIdApprovalStatusUrl = (invoiceId: number) => {
  return `/api/v1/invoices/${invoiceId}/approval-status`
}

/**
 * @summary Whether an invoice needs approving, and whether it has been
 */
export const getInvoicesInvoiceIdApprovalStatus = async (
  invoiceId: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<InvoiceApprovalStatus> => {
  return customFetch<InvoiceApprovalStatus>(getGetInvoicesInvoiceIdApprovalStatusUrl(invoiceId), {
    ...options,
    method: 'GET',
  })
}

export const getGetInvoicesInvoiceIdApprovalStatusQueryKey = (invoiceId: number) => {
  return [`/api/v1/invoices/${invoiceId}/approval-status`] as const
}

export const getGetInvoicesInvoiceIdApprovalStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetInvoicesInvoiceIdApprovalStatusQueryKey(invoiceId)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>> = ({
    signal,
  }) => getInvoicesInvoiceIdApprovalStatus(invoiceId, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: invoiceId !== null && invoiceId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesInvoiceIdApprovalStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>
>
export type GetInvoicesInvoiceIdApprovalStatusQueryError = unknown

export function useGetInvoicesInvoiceIdApprovalStatus<
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>,
  TError = unknown,
>(
  invoiceId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesInvoiceIdApprovalStatus<
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesInvoiceIdApprovalStatus<
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether an invoice needs approving, and whether it has been
 */

export function useGetInvoicesInvoiceIdApprovalStatus<
  TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>,
  TError = unknown,
>(
  invoiceId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdApprovalStatus>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetInvoicesInvoiceIdApprovalStatusQueryOptions(invoiceId, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetInvoicesStatsUrl = () => {
  return `/api/v1/invoices-stats`
}

/**
 * @summary Invoice counts by status
 */
export const getInvoicesStats = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<FinancialInvoices> => {
  return customFetch<FinancialInvoices>(getGetInvoicesStatsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetInvoicesStatsQueryKey = () => {
  return [`/api/v1/invoices-stats`] as const
}

export const getGetInvoicesStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoicesStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesStats>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetInvoicesStatsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicesStats>>> = ({ signal }) =>
    getInvoicesStats({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvoicesStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoicesStats>>>
export type GetInvoicesStatsQueryError = unknown

export function useGetInvoicesStats<
  TData = Awaited<ReturnType<typeof getInvoicesStats>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesStats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesStats>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesStats<
  TData = Awaited<ReturnType<typeof getInvoicesStats>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesStats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesStats>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesStats>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesStats<
  TData = Awaited<ReturnType<typeof getInvoicesStats>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Invoice counts by status
 */

export function useGetInvoicesStats<
  TData = Awaited<ReturnType<typeof getInvoicesStats>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesStats>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetInvoicesStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetInvoiceCompaniesIdInvoiceFieldsUrl = (id: number) => {
  return `/api/v1/invoice-companies/${id}/invoice-fields`
}

/**
 * @summary The company's details, named as an outgoing invoice names them
 */
export const getInvoiceCompaniesIdInvoiceFields = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<GetInvoiceCompaniesIdInvoiceFields200> => {
  return customFetch<GetInvoiceCompaniesIdInvoiceFields200>(
    getGetInvoiceCompaniesIdInvoiceFieldsUrl(id),
    {
      ...options,
      method: 'GET',
    },
  )
}

export const getGetInvoiceCompaniesIdInvoiceFieldsQueryKey = (id: number) => {
  return [`/api/v1/invoice-companies/${id}/invoice-fields`] as const
}

export const getGetInvoiceCompaniesIdInvoiceFieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetInvoiceCompaniesIdInvoiceFieldsQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>> = ({
    signal,
  }) => getInvoiceCompaniesIdInvoiceFields(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoiceCompaniesIdInvoiceFieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>
>
export type GetInvoiceCompaniesIdInvoiceFieldsQueryError = unknown

export function useGetInvoiceCompaniesIdInvoiceFields<
  TData = Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>,
  TError = unknown,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>,
          TError,
          Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoiceCompaniesIdInvoiceFields<
  TData = Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>,
          TError,
          Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoiceCompaniesIdInvoiceFields<
  TData = Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The company's details, named as an outgoing invoice names them
 */

export function useGetInvoiceCompaniesIdInvoiceFields<
  TData = Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>,
  TError = unknown,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getInvoiceCompaniesIdInvoiceFields>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetInvoiceCompaniesIdInvoiceFieldsQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetFinancialSummaryUrl = () => {
  return `/api/v1/financial-summary`
}

/**
 * @summary Revenue, unpaid invoices, top suppliers and what falls due
 */
export const getFinancialSummary = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<FinancialSummary> => {
  return customFetch<FinancialSummary>(getGetFinancialSummaryUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetFinancialSummaryQueryKey = () => {
  return [`/api/v1/financial-summary`] as const
}

export const getGetFinancialSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getFinancialSummary>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummary>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetFinancialSummaryQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFinancialSummary>>> = ({ signal }) =>
    getFinancialSummary({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFinancialSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFinancialSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFinancialSummary>>
>
export type GetFinancialSummaryQueryError = unknown

export function useGetFinancialSummary<
  TData = Awaited<ReturnType<typeof getFinancialSummary>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialSummary>>,
          TError,
          Awaited<ReturnType<typeof getFinancialSummary>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialSummary<
  TData = Awaited<ReturnType<typeof getFinancialSummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialSummary>>,
          TError,
          Awaited<ReturnType<typeof getFinancialSummary>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialSummary<
  TData = Awaited<ReturnType<typeof getFinancialSummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummary>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Revenue, unpaid invoices, top suppliers and what falls due
 */

export function useGetFinancialSummary<
  TData = Awaited<ReturnType<typeof getFinancialSummary>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummary>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFinancialSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetFinancialSummaryYearlyUrl = (params?: GetFinancialSummaryYearlyParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/financial-summary/yearly?${stringifiedParams}`
    : `/api/v1/financial-summary/yearly`
}

/**
 * @summary Revenue and cost, year by year, with the months alongside
 */
export const getFinancialSummaryYearly = async (
  params?: GetFinancialSummaryYearlyParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<FinancialYearlySummary> => {
  return customFetch<FinancialYearlySummary>(getGetFinancialSummaryYearlyUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetFinancialSummaryYearlyQueryKey = (params?: GetFinancialSummaryYearlyParams) => {
  return [`/api/v1/financial-summary/yearly`, ...(params ? [params] : [])] as const
}

export const getGetFinancialSummaryYearlyQueryOptions = <
  TData = Awaited<ReturnType<typeof getFinancialSummaryYearly>>,
  TError = unknown,
>(
  params?: GetFinancialSummaryYearlyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummaryYearly>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetFinancialSummaryYearlyQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFinancialSummaryYearly>>> = ({
    signal,
  }) => getFinancialSummaryYearly(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFinancialSummaryYearly>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFinancialSummaryYearlyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFinancialSummaryYearly>>
>
export type GetFinancialSummaryYearlyQueryError = unknown

export function useGetFinancialSummaryYearly<
  TData = Awaited<ReturnType<typeof getFinancialSummaryYearly>>,
  TError = unknown,
>(
  params: undefined | GetFinancialSummaryYearlyParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummaryYearly>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialSummaryYearly>>,
          TError,
          Awaited<ReturnType<typeof getFinancialSummaryYearly>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialSummaryYearly<
  TData = Awaited<ReturnType<typeof getFinancialSummaryYearly>>,
  TError = unknown,
>(
  params?: GetFinancialSummaryYearlyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummaryYearly>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialSummaryYearly>>,
          TError,
          Awaited<ReturnType<typeof getFinancialSummaryYearly>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialSummaryYearly<
  TData = Awaited<ReturnType<typeof getFinancialSummaryYearly>>,
  TError = unknown,
>(
  params?: GetFinancialSummaryYearlyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummaryYearly>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Revenue and cost, year by year, with the months alongside
 */

export function useGetFinancialSummaryYearly<
  TData = Awaited<ReturnType<typeof getFinancialSummaryYearly>>,
  TError = unknown,
>(
  params?: GetFinancialSummaryYearlyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummaryYearly>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFinancialSummaryYearlyQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetFinancialSummaryDetailedUrl = (params?: GetFinancialSummaryDetailedParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/financial-summary/detailed?${stringifiedParams}`
    : `/api/v1/financial-summary/detailed`
}

/**
 * @summary Revenue, cost and margin between two dates
 */
export const getFinancialSummaryDetailed = async (
  params?: GetFinancialSummaryDetailedParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<FinancialDetailedSummary> => {
  return customFetch<FinancialDetailedSummary>(getGetFinancialSummaryDetailedUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetFinancialSummaryDetailedQueryKey = (
  params?: GetFinancialSummaryDetailedParams,
) => {
  return [`/api/v1/financial-summary/detailed`, ...(params ? [params] : [])] as const
}

export const getGetFinancialSummaryDetailedQueryOptions = <
  TData = Awaited<ReturnType<typeof getFinancialSummaryDetailed>>,
  TError = unknown,
>(
  params?: GetFinancialSummaryDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummaryDetailed>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetFinancialSummaryDetailedQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFinancialSummaryDetailed>>> = ({
    signal,
  }) => getFinancialSummaryDetailed(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFinancialSummaryDetailed>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFinancialSummaryDetailedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFinancialSummaryDetailed>>
>
export type GetFinancialSummaryDetailedQueryError = unknown

export function useGetFinancialSummaryDetailed<
  TData = Awaited<ReturnType<typeof getFinancialSummaryDetailed>>,
  TError = unknown,
>(
  params: undefined | GetFinancialSummaryDetailedParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummaryDetailed>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialSummaryDetailed>>,
          TError,
          Awaited<ReturnType<typeof getFinancialSummaryDetailed>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialSummaryDetailed<
  TData = Awaited<ReturnType<typeof getFinancialSummaryDetailed>>,
  TError = unknown,
>(
  params?: GetFinancialSummaryDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummaryDetailed>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialSummaryDetailed>>,
          TError,
          Awaited<ReturnType<typeof getFinancialSummaryDetailed>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialSummaryDetailed<
  TData = Awaited<ReturnType<typeof getFinancialSummaryDetailed>>,
  TError = unknown,
>(
  params?: GetFinancialSummaryDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummaryDetailed>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Revenue, cost and margin between two dates
 */

export function useGetFinancialSummaryDetailed<
  TData = Awaited<ReturnType<typeof getFinancialSummaryDetailed>>,
  TError = unknown,
>(
  params?: GetFinancialSummaryDetailedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFinancialSummaryDetailed>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetFinancialSummaryDetailedQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
